import { useEffect } from "react";
import { Link } from 'react-router-dom';

export default function PhoneLinkTracking() {
    useEffect(() => {
        if (window.gtag) {
            window.gtag('config', 'AW-17005273287/v-jyCMPg2IEcEMfB36w_', {
                phone_conversion_number: '(562) 485-5485'
            });
        }
    }, []);

    return (
        <Link className='nav-link' style={{ fontWeight: 800 }} to="tel:+15624855485">
            <i className="la la-fw la-phone-volume me-1"></i>
            (562) 485-5485</Link>
    );
}
